





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { ProductImageDto } from '@eurogast/hub-client-typescript';
import ZoomableImage from '@/product-detail/ZoomableImage.vue';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component({ components: { ZoomableImage } })
export default class ImageSection extends Vue {

  @Prop({ required: true })
  public localImagePaths: string;

  @Prop({ required: true })
  public localProductName: string;

  public currentIndex: number = 0;
  private modalOpen: boolean = false;
  private isFirstAction: boolean = true;


  get imagePathsExist(): boolean {
    return this.images.length > 0;
  }

  get imagePaths3dExist(): boolean {
    return this.images3d.length > 0;
  }

  get images(): ProductImageDto[] {
    return ConfigService.parseImages(this.localImagePaths).filter((it) => !it.is3d);
  }

  get images3d(): ProductImageDto[] {
    const images = ConfigService.parseImages(this.localImagePaths).filter((it) => !!it.is3d);
    images.sort((i1, i2) => {
      if (i1.thumbnailPath.length !== i2.thumbnailPath.length) {
        return i1.thumbnailPath.length - i2.thumbnailPath.length;
      } else {
        return i1.thumbnailPath.localeCompare(i2.thumbnailPath);
      }
    });
    return images;
  }

  get currentImage(): ProductImageDto {
    if (this.show3dImage) {
      return this.imagePaths3dExist ? this.images3d[this.currentIndex] : null;
    } else {
      return this.imagePathsExist ? this.images[this.currentIndex] : null;
    }
  }

  private show3dImage: boolean = false;

  public setShow3dImage(value: boolean) {
    this.show3dImage = value;
  }

  public getShow3dImage(): boolean {
    return this.show3dImage;
  }

  public isCurrentImage(index: number): boolean {
    return index === this.currentIndex;
  }

  public setImageActive(index: number) {
    MatomoEvents.forProductImage.showOther.publish();
    this.currentIndex = index;
    this.setShow3dImage(false);
  }

  public doShow3dImage() {
    this.setShow3dImage(true);
    this.currentIndex = 0;
  }

  public previousImage() {
    this.trackImageInteraction();
    this.currentIndex -= 1;
    if (this.currentIndex < 0) {
      this.currentIndex = this.images3d.length - 1;
    }
  }

  public nextImage() {
    this.trackImageInteraction();
    this.currentIndex += 1;
    if (this.currentIndex >= this.images3d.length) {
      this.currentIndex = 0;
    }
  }

  public trackImageInteraction() {
    if (this.isFirstAction) {
      MatomoEvents.forProductImage.interaction.publish();
      this.isFirstAction = false;
    }
  }

  public openModal() {
    this.modalOpen = true;
    this.$nextTick(() => {
      (this.$refs.modal as HTMLElement).focus();
    });

  }

  public closeModal() {
    this.modalOpen = false;
  }

  public focusOut(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      this.closeModal();
    }
  }
}
